import { queryKeyFn } from '../../generated/sitContext';
export const timesheetsQueryKey = queryKeyFn({
    path: '/timesheets',
    operationId: 'getApiTimesheets',
    variables: {},
});
// @ts-expect-error -- intentionally omitting variables for better invalidations
export const timesheetsPaginatedQueryKey = queryKeyFn({
    path: '/timesheets-paginated',
    operationId: 'getApiTimesheetsPaginated',
    variables: {},
});
export const timesheetsPredicate = (query) => {
    return (query.queryKey.length === 1 ||
        (query.queryKey.length === 2 && typeof query.queryKey[1] === 'object'));
};
export function setTimesheetsQueryData(queryClient, updater) {
    // Optimistically update to the new value
    return queryClient.setQueriesData({
        queryKey: timesheetsQueryKey,
        predicate: timesheetsPredicate,
    }, updater);
}
function setPaginatedTimesheetsQueryData(queryClient, updater) {
    // Optimistically update to the new value
    return queryClient.setQueriesData({
        queryKey: timesheetsPaginatedQueryKey,
        predicate: timesheetsPredicate,
    }, updater);
}
export function updateTimesheetInTimesheetsQueryData(queryClient, id, updater) {
    // Unpaginated timesheets query
    setTimesheetsQueryData(queryClient, (old) => {
        if (!old)
            return old;
        return old.map((timesheet) => timesheet.id === id ? updater(timesheet) : timesheet);
    });
    // Paginated timesheets query
    setPaginatedTimesheetsQueryData(queryClient, (old) => {
        if (!old)
            return old;
        return {
            ...old,
            entries: old.entries.map((timesheet) => timesheet.id === id ? updater(timesheet) : timesheet),
        };
    });
}
export function getTimesheetFromTimesheetsQueryData(queryClient, id) {
    // Mobile uses unpaginated timesheets query
    // Web uses paginated timesheets query
    const unpaginedQueryData = queryClient.getQueriesData({
        queryKey: timesheetsQueryKey,
        predicate: timesheetsPredicate,
    });
    for (const queryData of unpaginedQueryData) {
        const [, timesheets] = queryData;
        if (!timesheets)
            continue;
        const timesheet = timesheets.find((timesheet) => timesheet.id === id);
        if (timesheet)
            return timesheet;
    }
    const paginedQueryData = queryClient.getQueriesData({
        queryKey: timesheetsPaginatedQueryKey,
        predicate: timesheetsPredicate,
    });
    for (const queryData of paginedQueryData) {
        const [, timesheetsPaginated] = queryData;
        if (!timesheetsPaginated)
            continue;
        const timesheet = timesheetsPaginated.entries.find((timesheet) => timesheet.id === id);
        if (timesheet)
            return timesheet;
    }
}
export const invalidateTimesheetsQuery = (queryClient) => {
    return Promise.all([
        queryClient.invalidateQueries({
            queryKey: timesheetsQueryKey,
            predicate: timesheetsPredicate,
        }),
        queryClient.invalidateQueries({
            queryKey: timesheetsPaginatedQueryKey,
            predicate: timesheetsPredicate,
        }),
    ]);
};
export const invalidateEverythingTimesheetsRelated = (queryClient) => {
    return Promise.all([
        // Note, no predicate here to invalidate all timesheets queries
        queryClient.invalidateQueries({ queryKey: timesheetsQueryKey }),
        queryClient.invalidateQueries({ queryKey: timesheetsPaginatedQueryKey }),
    ]);
};
//# sourceMappingURL=query.js.map